<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="list.length == 0 ? '' : '暂无更多数据'"
      @load="getOrderList"
      
    >
      <van-row v-if="list.length > 0" class="order">
        <van-col
          :span="24"
          class="bg-white orderItem m-b-05"
          v-for="(item, index) in list"
          v-show="item.state != 0"
          :key="index"
          @click="goOrderDetial(item)"
        >
          <p class="f-s-8 orderTitle">
            <van-icon name="checked" :color="editIcon(item)" />
            {{ tranText(item) }}
            <span class="f-l-r f-s-6" style="color:#9DA4AD">{{
              item.paymentDate
            }}</span>
          </p>
          <div class="van-ellipsis f-s-8 m-t-05 orderContext">
            {{ item.ctitle }}
          </div>
          <p class="m-t-05 f-s-7">
            实付<span class="m-l-02 colorF1">¥</span
            ><span class="f-s-12 colorF1">{{ item.practicalPrice }}</span>
          </p>
          <van-row
            class="f-s-7 footer"
            v-if="item.state == 1 || item.state == 5"
          >
            <span class="f-l-l">倒计时:</span>
            <!-- :time="item.pinendDate - Date.parse(new Date())" -->
            <van-count-down
              format="DD 天 HH:mm:ss"
              :time="item.timestamp"
              class="f-s-6 f-l-l time"
            />
            <van-button
              class="xz-button-info f-l-r GroupBtn"
              v-if="item.state == 1"
              @click="goPay(item)"
              >去支付</van-button
            >
            <van-button
              class="xz-button-info f-l-r GroupBtn"
              v-if="item.state == 5"
              @click="goOrderDetial"
              >邀请好友</van-button
            >
          </van-row>
        </van-col>
      </van-row>
    <NoData v-else text="您还没有购买过" path="/liveList" :empty="empty" />

    </van-list>

  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      time: 1564864842,
      loading: false,
      finished: false,
      empty:require("@/assets/imgs/empty/noList.png")
    };
  },
  methods: {
    getOrderList() {
      this.$emit("getOrderList");
    },
    goPay(item){
      if(item.pintype == 2){
        this.$router.push({
          path: "/details",
          query: {
            cid: item.cid,
          },
        });
        // window.location.href = `${this.GLOBAL.payUrl}/pay?cid=${item.cid}&acttypeid=${item.aid}`;
      }else {
        this.$router.push({ path: "/BIMDetials", query: { pid: item.cid } })
      }
      
    },
    // 跳转到订单详情界面
    goOrderDetial(item) {
      switch (item.state) {
        case 2:
          this.$router.push({
            path: "/orderDetial",
            query: { userCourseId: item.userCourseId },
          });
          break;
        case 5:
          this.$router.push({ path: "/BIMDetials", query: { pid: item.cid} });
          break;
      }
    },
    tranText(item) {
      switch (item.state) {
        case 1:
          return "待支付";
        case 2:
          return "支付成功";
        case 3:
          return "已过期";
        case 4:
          return "订单退款关闭";
        case 5:
          return "已支付-待成团";
        case 6:
          return "退款中";
        case 7:
          return "已退款";
        default:
          return "退款失败-联系学习规划老师";
      }
    },
    editIcon(item){
      switch(item.state){
        case 1:
          return 'red';
        case 2:
          return 'green';
        case 5:
          return 'orange'
      }
    }
  },
};
</script>

<style lang="less" scoped>
.order {
  padding: 0.7rem 0.8rem 0rem 0.8rem;
}
.orderItem {
  padding: 0.7rem;
  border-radius: 0.2rem;
}
.GroupBtn {
  border-radius: 0.8rem;
  width: 4.5rem;
  height: 1.6rem;
  color: white;
}
.time {
  color: #f18340;
  height: 1.6rem;
  line-height: 2rem;
}
.footer {
  height: 1.6rem;
  line-height: 2rem;
}
.colorF1 {
  color: #f18340;
}
.orderContext {
  color: #292e35;
  font-weight: 500;
}
.orderTitle {
  border-bottom: 1px solid #f6f6f6;
  padding-bottom: 0.3rem;
}
</style>
